export default {"src":"/_next/static/media/use.276131f6.svg","height":457,"width":621};